$(document).ready(function () {
    //carousel-control

    $("#myCarousel").mouseover(function () {
      $("#myCarousel .carousel-control").show();
    });

    $("#myCarousel").mouseleave(function () {
      $("#myCarousel .carousel-control").hide();
    });

    //active thumbnail

    $("#thumbCarousel .thumb").on("click", function () {
      $(this).addClass("active");
      $(this).siblings().removeClass("active");
    });

    //carousel slides

    $("#myCarousel").on("slid.bs.carousel", function () {
      var index = $(".carousel-inner .item.active").index();
      //console.log(index);
      var thumbnailActive = $(
        '#thumbCarousel .thumb[data-slide-to="' + index + '"]'
      );
      thumbnailActive.addClass("active");
      $(thumbnailActive).siblings().removeClass("active");
      //console.log($(thumbnailActive).siblings());
    });

    let thumbSlider = $(".owl-thumb-slider");
    $(thumbSlider).owlCarousel({
      nav: true,
      dots: false,
      navRewind: true,
      responsiveClass: true,
      autoplay: false,
      responsive: {
        0: {
          items: 3,

          slideBy: 3,
        },
        600: {
          items: 4,
          nav: true,
          slideBy: 4,
        },
        1000: {
          items: 5,
          slideBy: 5,
        },
      },
    });
  });





$(document).ready(function(){
  if($(window).width() <= 767) {
    console.log("test");

   $(".filterbutton").click(function(){
  console.log("test2222");
    $("#filterSidebar").toggle();
     $(this).toggleClass("active");
  });
      }
});